import Get from '../services/Get';
import Post from '../services/Post';
import Put from '../services/Put';

import { nexcareVersion } from '../config/serviceConfig';

const getInitiateUserCustomer = (token) => Get(`/${nexcareVersion}/nexcare/user-customer/initiate?filter=user_customer.customer_type eq distributor`, token);
const getListUserCustomer = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-customer?page=${page}&limit=${limit}&filter=user_customer.customer_type eq distributor&order=user_nexcare.alias_name asc`, token);
const getDetailUserCustomer = (id, token) => Get(`/${nexcareVersion}/nexcare/user-customer/${id}`, token);

const putDataPicContact = (data, id, token) => Put(`/${nexcareVersion}/nexcare/ticket/contact/${id}`, data, token);
const putDataEditPicContact = (data, id, token) => Put(`/${nexcareVersion}/nexcare/contact/${id}`, data, token);

const postDataAddContact = (data, token) => Post(`/${nexcareVersion}/nexcare/contact`, data, token);

const getListCustomerServiceMember = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-cs/member?page=${page}&limit=${limit}&order=alias_name asc`, token);

const getListCustomer = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getSearchCustomer = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/user-customer/distributor?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);

const getListPrincipal = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-customer/principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getSearchPrincipal = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/user-customer/principal?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);

const API_CONTACT = {
    getInitiateUserCustomer,
    getListUserCustomer,
    getDetailUserCustomer,
    putDataPicContact,
    putDataEditPicContact,
    postDataAddContact,
    getListCustomerServiceMember,
    getListCustomer,
    getSearchCustomer,
    getListPrincipal,
    getSearchPrincipal
}

export default API_CONTACT;